import Vue from 'vue';
import Vuex from 'vuex';

import auth from '~store/auth';
import document from '~store/document';
import snackbar from '~store/snackbar';
import statistics from '~store/statistics';
import businesses from '~store/businesses';
import managers from '~store/managers';
import sessions from '~store/sessions';
import prompt from '~store/prompt';
import programs from '~store/programs';
import payments from '~store/payments';
import modals from '~store/modals';
import emails from '~store/emails';
import users from '~store/users';
import goals from '~store/goals';
import reminders from '~store/reminders';
import coupons from '~store/coupons';
import mindfulMinute from '~store/mindfulMinute';
import notes from '~store/notes';
import records from '~store/records';
import settings from '~store/settings';
import landingPages from '~store/landingPages';
import player from '~store/player';
import activityReport from '~store/activityReport';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        document,
        snackbar,
        statistics,
        businesses,
        sessions,
        managers,
        prompt,
        programs,
        payments,
        modals,
        emails,
        users,
        goals,
        reminders,
        coupons,
        mindfulMinute,
        notes,
        records,
        settings,
        landingPages,
        player,
        activityReport
    }
});
